
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import React from 'react'
import { KTCard } from '../../../../../../_metronic/helpers'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
import { useAuth } from '../../../../auth'


const features = (isPartner = false, isSupplyChainManager = false, currentUser: any = {}) => [

    { name: 'Impact Partner', icon: 'impact partnersBD', to: 'impact-partner' },
    { name: 'My Portfolio', icon: 'commitmentBD', to: 'My-Portfolio' },
    { name: 'Fulfillment', icon: 'fulfillmentbd', to: 'fullfilment' },
    { name: 'Engagement', icon: 'engagementBD', to: 'engagement' },
    // { name: 'Coupons', icon: 'couponsBD', to: 'coupons' },
    { name: 'IP Tier', icon: 'membership tierBD', to: 'membership-tiers' },

]

const Menu = () => {
    const { isPartner, isSupplyChainManager, currentUser } = useAuth()
    console.log({ isPartner })
    return (
        <KTCard addCard={false}>
            <div className='row g-xl-4'>
                {features(isPartner, isSupplyChainManager, currentUser).map((eachFeatures, eachIndex) => (
                    <div key={eachIndex + 1 + ''} className='col col-lg-2'>
                        <Link className={clsx('menu-link without-sub')} to={eachFeatures.to}>
                            <Card4
                                // icon={`/media/svg/files/${eachFeatures.icon}.png`}
                                icon={`/media/svg/files/${eachFeatures.icon}.png`}
                                title={eachFeatures.name}
                                description=''
                            />
                        </Link>
                    </div>
                ))}
            </div>
        </KTCard>
    )
}

const BDMenu = () => <Menu />
export { BDMenu }












